module.exports = __webpack_public_path__ + "static/img/pedals-boost.df88253.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/pedals-boost.png
// module id = D0Y7
// module chunks = 12